<script lang="ts" setup>
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import ForwardRequestStatusEnum from '~/enums/ForwardRequestStatusEnum'
import { Routes } from '~/enums/Routes'
import Tooltip from '~/components/Tooltip.vue'

const { t } = useLang()

const props = defineProps({
  status: {
    type: Number,
    required: true,
  },
  frId: {
    type: Number,
    required: true,
  },
})

const statusText = computed(() => {
  switch (props.status) {
    case ForwardRequestStatusEnum.PriceCalculation:
      return t('site_pro.status.fr_status.in_progress')
    case ForwardRequestStatusEnum.AwaitingPayment:
      return t('site_pro.status.fr_status.awaiting_payment')
    case ForwardRequestStatusEnum.Paid:
      return t('site_pro.status.fr_status.paid')
    case ForwardRequestStatusEnum.Shipped:
      return t('site_pro.status.fr_status.shipped')
  }

  return '-'
})

const statusTooltipText = computed(() => {
  switch (props.status) {
    case ForwardRequestStatusEnum.PriceCalculation:
      return t('site_pro.status.fr_status_tooltip.in_progress')
    case ForwardRequestStatusEnum.Paid:
      return t('site_pro.status.fr_status_tooltip.paid')
  }

  return null
})

function redirect() {
  if (Number(props.status) === ForwardRequestStatusEnum.AwaitingPayment) {
    return navigateTo(getLocalizedRoute(Routes.Account.SiteProPaymentId, { id: String(props.frId) }))
  }
}
</script>

<template>
  <div
    class="status-holder"
    :class="{ 'clickable !bg-brand-primaryLight !border-red': status === ForwardRequestStatusEnum.AwaitingPayment }"
    @click="redirect">
    <i
      class="fa"
      :class="{
        'fa-truck text-green': status === ForwardRequestStatusEnum.Shipped,
        'fa-file-lines': status === ForwardRequestStatusEnum.AwaitingPayment,
        'fa-clock text-quoteYellow': status === ForwardRequestStatusEnum.PriceCalculation,
        'fa-check-circle text-greenDark': status === ForwardRequestStatusEnum.Paid,
      }" />
    <span class="text-black dark:text-white">{{ statusText }}</span>
    <Tooltip v-if="statusTooltipText" :text="statusTooltipText">
      <i class="fa fa-question-circle text-xs text-neutral3 dark:text-dmText3 cursor-pointer" />
    </Tooltip>
  </div>
</template>

<style lang="postcss" scoped>
.status-holder {
  @apply flex items-center whitespace-nowrap gap-2 xl:gap-1 rounded-full bg-neutral8 dark:bg-dmGray1 border border-neutral7 py-[14px] px-[16px] xl:py-[6px] xl:px-[10px] dark:border-dmGray4;

  &.clickable {
    @apply cursor-pointer hover:bg-neutral7 dark:!bg-dmGray1;
  }
}
</style>
